module.exports = "/virtual-football-league/img/video/video-header-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/video-header-bck.png
// module id = 360
// module chunks = 4